module.exports = __webpack_public_path__ + "img/2@2x.ed9a4ebe.png";